export default function getCurrentLocale<T extends string>(
  availableLocales: ReadonlyArray<T>,
): T {
  const languages = navigator.languages as T[];
  for (const language of languages) {
    for (const locale of availableLocales) {
      if (locale === language) return locale;
      if (language.startsWith(`${locale}_`)) return locale;
    }
  }
  for (const language of languages) {
    for (const locale of availableLocales) {
      if (locale.startsWith(`${language}-`)) return locale;
    }
  }
  return availableLocales[0];
}
